import { getUnAuthRequest } from '../../../utils'
import { CurrenciesState } from './types'

export const fetchCurrencies = (): Promise<CurrenciesState> => getUnAuthRequest('/v2/currencies')
